export const aiAssitantChatbotText = {
  noCreditsForLearner:
    "We're sorry! Our AI chat feature is temporarily unavailable. Please try again later or contact your instructor for assistance.",
  chatHistoryDeleteConfirmation:
    'Are you sure you want to delete your visible chat history? This action cannot be undone, and all messages will be permanently removed from your view',
  yes: 'Yes',
  clearTooltip: 'Delete chat history',
  thinking: 'Thinking...',
  you_can_start_typing: 'You can start by typing a message below',
};
